// extracted by mini-css-extract-plugin
export default {"wrapper":"iB0Pe_dYMp0i7HmBTY6g","variables":"XXDaK1joz8FrFdevyX_m","variable":"fXi0DkUGqr5gLKLpW8kR","name":"D5MBGo0529a0ngfVtvgy","value":"sZiCjBf0vLnBAzKrcSAo"};